<template>
  <BCard>
    <BRow class="justify-between items-center">
      <strong class="text-[20px] text-black font-semibold ml-1">
        Rekonsiliasi
      </strong></BRow>
    <BRow class="justify-end flex mr-1">
      <BButton
        class="button-ajukan"
        variants="primary"
        size="sm"
        @click="$router.push('/rekonsiliasi/pengajuan')"
      >
        <div class="flex items-center gap-3">
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/add.svg"
          >
          Ajukkan File Pembanding
        </div>
      </BButton>
    </BRow>
    <BRow class="p-1 ">
      <BOverlay
        :show="loadingData"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        class=" w-100"
        rounded="sm"
      >
        <BTable
          bordered
          show-empty
          :items="dataFetch"
          :fields="fields"
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          sticky-header="500px"
          class="mt-2"
          @scroll.native="handleScroll"
        >
          <template #cell(created_at)="data">
            <span>
              {{ DAY_MONTH_YEAR(data.item.uploaded_date) }}
            </span>
          </template>
          <template #cell(expedition)="data">
            <span>
              <div class="flex justify-center">
                <img
                  style="height:30px;"
                  :src="data.item.shipping_image_url"
                >
              </div>
            </span>
          </template>
          <template #cell(description)="data">
            <span
              v-b-tooltip.hover
              :title="data.item.description"
              class="d-inline-block text-truncate"
              style="max-width: 150px !important;"
            >
              {{ data.item.description || '-' }}
            </span>
          </template>
          <template #cell(invoice_date)="data">
            <span>
              {{ DAY_MONTH_YEAR(data.item.invoice_date) }}
            </span>
          </template>
          <template #cell(status)="data">
            <span
              :class="data.item.status"
              class="label_status"
            >
              {{ classStatus(data.item.status) }}
            </span>
          </template>
          <template #cell(result)="data">
            <button
              :class="data.item.missing_excel_url ? 'text-[#08A0F7] underline cursor-pointer' : 'text-black'"
              class="border-none bg-transparent p-0 focus:outline-none hover:opacity-80 transition"
              :disabled="!data.item.missing_excel_url"
              @click="downloadXcel(data.item.missing_excel_url)"
            >
              {{ data.item.missing_excel_url ? 'Hasil Berbeda' : '-' }}
            </button>
          </template>
          <template #cell(action)="data">
            <span>
              <div class="flex justify-center">
                <BButton
                  v-if="
                    data.item.reconciliation_excel_url === null && data.item.status_download
                      === 'none' && data.item.status
                        === 'completed'
                  "
                  v-b-tooltip.hover
                  class="p-0"
                  variant="outline-light"
                  title="Click untuk generate link download file pembanding"
                  @click="generateDownload(data.item._id)"
                >
                  <img
                    v-if="!loadingGenerateDownload[data.item._id]"
                    :alt="data.item.reconciliation_excel_url"
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/refresh-2.svg"
                  >
                  <b-spinner
                    v-else
                    variant="primary"
                  />
                </BButton>
                <BButton
                  v-if="
                    data.item.reconciliation_excel_url !== null && data.item.status === 'completed'
                  "
                  class="p-0"
                  variant="outline-light"
                  @click="downloadXcel(data.item.reconciliation_excel_url)"
                >
                  <img
                    :alt="data.item.reconciliation_excel_url"
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/document-download.svg"
                  >
                </BButton>
              </div>
            </span>
          </template>
        </BTable>
      </BOverlay>
    </BRow>
  </BCard>
</template>

<script>
import {
  BCard, BRow, BButton, BOverlay,
} from 'bootstrap-vue'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { newAxiosIns } from '@/libs/axios'
import { configTable } from './config'

export default {
  components: {
    BCard,
    BRow,
    BButton,
    BOverlay,
  },
  data() {
    return {
      fields: configTable,
      loadingData: false,
      limit: 25,
      offset: 0,
      dataFetch: [],
      isLastData: false,
      loadingGenerateDownload: {},
      DAY_MONTH_YEAR,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    classStatus(value) {
      if (value === 'completed') return 'Selesai'
      if (value === 'onprogress') return 'On Progress'
      if (value === 'failed') return 'Gagal'
      return ''
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.getData()
      }
    },
    async getData() {
      if (this.loadingData || this.isLastData) return
      this.loadingData = true
      const url = `/reconciliation/api/v1/reconciliations?limit=${this.limit}&offset=${this.offset}`
      await newAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.loadingData = false
          if (data) {
            this.dataFetch = [...this.dataFetch, ...data]
          }
          this.offset = this.dataFetch.length
          if (!data || data.length < this.limit) {
            this.isLastData = true
          }
        })
        .catch(err => {
          this.$toast_error({ message: err.message })
        })

      this.loadingData = false
    },
    async generateDownload(id) {
      this.$set(this.loadingGenerateDownload, id, true)
      const url = `/reconciliation/api/v1/reconciliations/${id}/download`
      await newAxiosIns
        .get(url)
        .then(res => {
          setTimeout(() => {
            this.limit = 25
            this.offset = 0
            this.dataFetch = []
            this.getData()
            this.$set(this.loadingGenerateDownload, id, false)
          }, 5000)
        })
        .catch(err => {
          this.$toast_error({ message: err.message })
          this.$set(this.loadingGenerateDownload, id, false)
        })
    },
    downloadXcel(e) {
      window.open(e)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './Rekonsiliasi.scss';
</style>
